import { AimOutlined } from "@ant-design/icons"

export const Coordinates = (props:{lat:number, lng: number}) => {
  return (
    <>
      <span style={{ textDecoration: "none", fontSize: "16px", color: "#3C4043", marginLeft:"1em", cursor:'pointer', fontWeight: 500 }}>
        Coordenadas              
      </span>
      <div className="title-box">
        <div style={{ margin: "1em 0 0 0", display: "flex", justifyContent: "flex-start" }}>
            <span style={{ color: "slategrey" }}>              
                <AimOutlined/> Lat: {props.lat?.toFixed(4)} Lng: {props.lng?.toFixed(4)}
            </span>
        </div>                
      </div>
    </>
  )
}
